/* eslint-disable @typescript-eslint/no-explicit-any */
import { NextArticlePath } from 'src/api/article/dataArticle';

import {
  Affiliate,
  Offer as DiscountData,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
} from 'src/api/landing/landing.graphql';

const getDataArticleSection = (
  articles: NextArticlePath[]
): {
  tag: string;
  url: string;
}[] => {
  const getTruncate = (title: string): string => {
    let truncateTitle = title.split('|');
    truncateTitle = truncateTitle[0].split('-');
    return truncateTitle[0];
  };

  const data = articles.map(
    (item: { params: { slug: string; title: string } }) => ({
      tag: getTruncate(item.params.title),
      url: `/listas/${item.params.slug}`,
    })
  );

  data.sort((a, b): number => {
    if (a.tag < b.tag) {
      return -1;
    }
    if (a.tag > b.tag) {
      return 1;
    }
    return 0;
  });

  return data;
};

const getDataBenefitSection = (): string[] => {
  const data = [
    'Aprende de los mejores audiolibros y meditaciones sin límites.',
    'Escucha a los expertos con nuestros Beek Originales.',
    'Descarga y escucha con y sin conexión en cualquier lugar.',
    'Sin compromiso, cancela en cualquier momento.',
  ];
  return data;
};

export type Offer = {
  amountOff?: number | null;
  finishDate: string;
  id: string;
  interval: number;
  intervalUnit: string;
  percentageOff?: number | null;
  slug: string;
  startDate: string;
  validPlans: string[];
  validProviders: string[];
};

const getDataDiscount = (
  discountData: DiscountData | null
): {
  hasDiscount: boolean;
  price: string;
  discountPrice: string;
  discountPercentage: string;
  urlImage: string;
  interval: number;
  intervalUnit: string;
  affiliate?: Affiliate | null;
  offer: Offer;
} | null => {
  if (discountData) {
    const total = 249;
    const price = `$${String(total)}MXN`;
    const discountPercentage = `-${(
      (discountData.amountOff! / total) *
      100
    ).toFixed()}%`;
    const discountPrice = `$${String(total - discountData.amountOff!)}MXN`;
    const affiliateInternalName = discountData.affiliate?.internalName;
    const data = {
      hasDiscount: true,
      price,
      discountPrice,
      discountPercentage,
      urlImage: `https://cdn.beek.io/beek-affiliates/${affiliateInternalName}/${affiliateInternalName}.svg`,
      interval: discountData.interval,
      intervalUnit: discountData.intervalUnit,
      affiliate: discountData.affiliate,
      offer: {
        amountOff: discountData.amountOff,
        finishDate: discountData.finishDate,
        id: discountData.id,
        interval: discountData.interval,
        intervalUnit: discountData.intervalUnit,
        percentageOff: discountData.percentageOff,
        slug: discountData.slug,
        startDate: discountData.startDate,
        validPlans: discountData.validPlans,
        validProviders: discountData.validProviders,
      },
    };
    return data;
  }
  return null;
};

const getDataPlans = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  plansData: any
): Record<string, string>[] | null | any => {
  if (plansData) {
    const { subscriptionPlansData } = plansData;
    let totalMonthly = 0;
    const data = subscriptionPlansData.map((plan: any, i: any) => {
      if (i === 0) {
        totalMonthly = plan.amount * 12;
        return {
          id: plan.id,
          amount: `$${plan.amount}MXN`,
          intervalUnit: plan.interval_unit,
        };
      }
      const savedMoney = totalMonthly - plan.amount;
      return {
        id: plan.id,
        amount: `$${plan.amount}MXN`,
        intervalUnit: plan.interval_unit,
        savedMoney: `$${savedMoney}MXN`,
      };
    });
    return data.reverse();
  }
  return null;
};

const Helpers = {
  getDataArticleSection,
  getDataBenefitSection,
  getDataDiscount,
  getDataPlans,
};

export default Helpers;
